import { Component, OnInit } from '@angular/core';
import { ProductService } from '../../services/product.service';
import { Product } from '../../entities/product.entities'
import { ActivatedRoute } from '@angular/router'
import { HeaderComponent } from '../../header/header.component';
import { Title } from '@angular/platform-browser';

import { AngularFireDatabase, FirebaseListObservable } from "angularfire2/database-deprecated";
import { RouterModule, Router } from '@angular/router';
import { FirebaseApp } from 'angularfire2';

import { Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-item-product',
  templateUrl: './item-product.component.html',
  styleUrls: ['./item-product.component.css']
})
export class ItemProductComponent implements OnInit {

  private products: Product[] = [];
  titles;
  constructor(private meta: Meta,private productService: ProductService, private activatedRoute: ActivatedRoute, private titleService: Title, private af: AngularFireDatabase, private firebaseApp: FirebaseApp) {

    //this.header.itemDropdown = false;

    this.activatedRoute.params.subscribe(params => {
      this.products = [];
      let a = params['id'];
      this.productService.getProduct().subscribe((snapshot) => {
        let index: number = 0;
        for (var i = 0; i < snapshot.length; i++) {
          if (snapshot[i].type == a) {
            this.products[index] = snapshot[i]
            let typeId = snapshot[i].type
            let getType = this.af.list('Menu')
            getType.subscribe((snap) => {
              for (var u = 0; u < snap.length; u++) {
                if (typeId == snap[u].Id) {
                  this.titleService.setTitle(snap[u].Name);
                  this.titles = snap[u].Name;
                  this.meta.addTag({ name: 'description', content: snap[u].MetaDescript });
                  this.meta.addTag({ name: 'keywords', content: snap[u].MetaKeywords });

                  console.log(snap[u].MetaDescript)
                }
              }
            })
            index++;
          }
        }
      });
    })
  }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/components/item-product/item-product.component.ts